export const BOOKING_URL = "https://hammammensspa.com/book?branch=delhi";
export const WHATSAPP_URL = "https://wa.me/919560656913";
export const PHONE_DISPLAY = "+91 95606 56913";
export const PHONE_TEL = "tel:+919560656913";
export const EMAIL_DISPLAY = "info@hammammensspa.com";
export const GOOGLE_MAPS_URL = "https://maps.app.goo.gl/oT8hJtohHm2YajVy6";
export const BUSINESS_NAME = "Hammam Men's Spa";
export const ADDRESS_LINE = "A-35, Block A2, Rajouri Garden, New Delhi, 110027";
export const ADDRESS_SHORT = "Rajouri Garden, New Delhi";

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "Facilities", href: "/facilities" },
  { label: "Doorstep Delhi", href: "/doorstep" },
  { label: "Memberships", href: "/memberships" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export const HERO_BADGES = [
  "100% Discreet & Inclusive",
  "Near Rajouri Garden Metro",
  "Delhi's #1 Male Spa",
];

export const BRANCH_HIGHLIGHTS = [
  {
    icon: "MapPin",
    title: "Prime Delhi Location",
    desc: "Near Rajouri Garden Metro Station, Block A2 — minutes from Central Delhi.",
  },
  {
    icon: "ShieldCheck",
    title: "Total Discretion & Privacy",
    desc: "Soundproof private therapy suites with attached showers.",
  },
  {
    icon: "Sparkles",
    title: "Top Rated Therapists",
    desc: "Highly trained, courteous & polite male staff.",
  },
  {
    icon: "Car",
    title: "Doorstep Service Available",
    desc: "Servicing Rajouri Garden, West Delhi & hotels across New Delhi.",
  },
];

export const FACILITIES = [
  {
    title: "Steam & Sauna Bath",
    desc: "Heated eucalyptus therapy for deep relaxation and muscle relief.",
    image: "/steam_room_hammam.webp",
  },
  {
    title: "Sunbath & Lounge Area",
    desc: "Recline, unwind and recharge in ambient luxury lighting.",
    image: "/sunbath_area.png",
  },
  {
    title: "Discreet Dark Room",
    desc: "Sensory relaxation lounge designed for privacy & peace.",
    image: "/dark_room_hammam.webp",
  },
  {
    title: "Drinks & Lounge Bar",
    desc: "In-house fresh juices, gourmet tea & herbal refreshments.",
    image: "/services/drinks_hammam.webp",
  },
];

export const SERVICES = [
  {
    slug: "service-red",
    name: "Service Red",
    duration: "45 Min",
    price: "₹1,500",
    desc: "30 Min Relaxing Massage + 15 Min Hot Shower. Deep stress release blending soothing massage techniques.",
    image: "/services/SERVICE-RED-HAMMAM.png",
    theme: "red",
    highlights: [
      "30 Minutes Relaxing Body Massage",
      "15 Minutes Hot / Cold Shower",
      "Choice of Organic Essential Oils",
    ],
  },
  {
    slug: "service-green",
    name: "Service Green",
    duration: "60 Min",
    price: "₹2,000",
    desc: "45 Min Full Body Massage + Hot/Cold Shower. An extended relaxation ritual designed to melt away muscle tension.",
    image: "/services/SERVICE-GREEN-HAMMAM.png",
    theme: "green",
    highlights: [
      "45 Minutes Full Body Muscle Relief",
      "15 Minutes Hot Refreshing Shower",
      "Complimentary Herbal Tea & Drinks",
    ],
  },
  {
    slug: "service-yellow",
    name: "Service Yellow",
    duration: "90 Min",
    price: "₹2,500",
    desc: "45 Min Massage + 45 Min Full Facility Access (Jacuzzi, Steam, Dark Room, Lounge). Our signature wellness experience.",
    image: "/services/Service-Yellow.png",
    theme: "yellow",
    highlights: [
      "45 Minutes Therapeutic Massage",
      "45 Minutes Steam, Jacuzzi & Dark Room Access",
      "Full Facility & Bar Privileges",
    ],
  },
  {
    slug: "service-rainbow",
    name: "Service Rainbow",
    duration: "90 Min",
    price: "₹3,000",
    desc: "60 Min Deep Tissue Therapy + 30 Min Spa Facilities & Refreshments. Ultimate body harmony & rejuvenation ritual.",
    image: "/services/SERVICE-RAINBOW.png",
    theme: "rainbow",
    highlights: [
      "60 Minutes Deep Tissue & Aromatherapy Massage",
      "30 Minutes Steam & Jacuzzi Bath",
      "VIP Lounge & Refreshment Access",
    ],
  },
  {
    slug: "body-polishing",
    name: "Full Body Scrub & Polishing",
    duration: "60 Min",
    price: "₹2,500",
    desc: "Exfoliating organic scrub to remove dead skin cells and leave your skin glowing, smooth, and revitalized.",
    image: "/services/BODY-POLISHING.png",
    theme: "yellow",
    highlights: [
      "Exfoliating Herbal Body Scrub",
      "Skin Hydration & Polish Treatment",
      "Warm Herbal Shower",
    ],
  },
  {
    slug: "trimmer-service",
    name: "Trimmer & Body Grooming",
    duration: "45 Min",
    price: "₹1,200",
    desc: "Professional hygienic male body trimming and precise grooming by experienced therapists.",
    image: "/services/TRIMMER.png",
    theme: "green",
    highlights: [
      "Hygienic Body Hair Trimming",
      "Precision Beard & Body Grooming",
      "Soothing Post-Grooming Lotion",
    ],
  },
  {
    slug: "veet-waxing",
    name: "Veet & Waxing Ritual",
    duration: "60 Min",
    price: "₹2,200",
    desc: "Smooth hair removal treatment designed for gentlemen desiring smooth, hair-free skin with minimal discomfort.",
    image: "/services/VEET-WAXING.png",
    theme: "red",
    highlights: [
      "Gentle Waxing / Veet Application",
      "Full Body Smooth Hair Removal",
      "Cooling Aloe Vera Aftercare",
    ],
  },
];

export const MEMBERSHIPS = [
  {
    tier: "Silver",
    pay: "₹10,000",
    credit: "₹12,000",
    accent: "text-slate-300",
    border: "hover:border-slate-300/60",
    description: "Ideal for regular monthly relaxation and essential spa perks.",
  },
  {
    tier: "Gold",
    pay: "₹25,000",
    credit: "₹32,000",
    accent: "text-amber-400",
    border: "hover:border-amber-400/60",
    description: "Our most popular VIP tier with extra bonus wallet credit.",
  },
  {
    tier: "Platinum",
    pay: "₹50,000",
    credit: "₹65,000",
    accent: "text-emerald-400",
    border: "hover:border-emerald-400/60",
    description: "Ultimate luxury membership for true wellness connoisseurs.",
  },
];

export const MEMBERSHIP_BENEFITS = [
  "Free Jacuzzi & Steam upgrades on every visit",
  "Priority slot booking for peak evening hours",
  "15% Discount on Doorstep massages across Delhi",
  "Complimentary lounge drinks & premium refreshments",
];

export const IMAGES = {
  hero: "/hero_image_hammam.png",
  doorstep: "/hero_image_hammam.png",
  about: "/branches/rajouri_garden_1.jpeg",
};

export const DELHI_PHOTOS = [
  "/branches/rajouri_garden_1.jpeg",
  "/branches/rajouri_garden_2.jpeg",
  "/branches/rajouri_garden_3.jpeg",
  "/branches/rajouri_garden_4.jpeg",
  "/branches/rajouri_garden_5.jpeg",
];
